import apiClient from './apiClient';

// Tüm tedavileri getir
export const getTreatments = async () => {
  try {
    const response = await apiClient.get('/treatments?populate=*');
    console.log('Ham tedavi verisi:', response.data);

    return response.data.data.map(treatment => {
      return {
        id: treatment.id,
        documentId: treatment.documentId,
        title: treatment.title,
        slug: treatment.slug,
        shortDesc: treatment.shortDesc,
        category: treatment.treatmentCategory?.identifier || 'genel',
        image: treatment.imageUrl,
        heroImage: treatment.heroImage,
        createdAt: treatment.createdAt,
        updatedAt: treatment.updatedAt
      };
    });
  } catch (error) {
    console.error('Tedaviler getirilirken hata:', error);
    return [];
  }
};

// Belirli bir slug'a sahip tedaviyi getir
export const getTreatmentBySlug = async (slug) => {
  try {
    console.log('Aranan slug:', slug);
    const response = await apiClient.get(`/treatments?filters[slug][$eq]=${slug}&populate=*`);
    console.log('Slug ile gelen yanıt:', response.data);

    if (!response.data?.data?.[0]) {
      console.log('Tedavi bulunamadı');
      return null;
    }

    const treatment = response.data.data[0];
    console.log('İşlenecek tedavi verisi:', treatment);

    return {
      id: treatment.id,
      documentId: treatment.documentId,
      title: treatment.title,
      slug: treatment.slug,
      shortDesc: treatment.shortDesc,
      category: treatment.treatmentCategory?.identifier || 'genel',
      image: treatment.imageUrl,
      heroImage: treatment.heroImage,
      content: parseBlocks(treatment.tblocks),
      createdAt: treatment.createdAt,
      updatedAt: treatment.updatedAt,
      treatmentCategory: treatment.treatmentCategory
    };
  } catch (error) {
    console.error('Tedavi detayı getirilirken hata:', error);
    return null;
  }
};

// tblocks içeriğini parse et
const parseBlocks = (blocks = []) => {
  console.log('parseBlocks - Ham blocks verisi:', blocks); // Debug
  
  return blocks.map((block, index) => {
    console.log(`parseBlocks - Block ${index}:`, block); // Debug
    console.log(`parseBlocks - Block component:`, block.__component); // Debug
    
    switch (block.__component) {
      case 'shared.t-rich':
        console.log('Rich text block:', block.text); // Debug
        return {
          type: 'rich-text',
          content: block.text
        };
      case 'shared.t-subtitle-section':
        console.log('Subtitle block:', block.subtitle); // Debug
        return {
          type: 'subtitle',
          content: block.subtitle
        };
      case 'shared.t-sub-content':
        console.log('Sub-content block:', block.content); // Debug
        return {
          type: 'sub-content',
          content: block.content
        };
      default:
        console.log('Bilinmeyen component:', block.__component); // Debug
        return null;
    }
  }).filter(Boolean);
};

// Tüm tedavi kategorilerini getir
export const getTreatmentCategories = async () => {
  try {
    const response = await apiClient.get('/treatment-categories?populate=*');
    console.log('Kategoriler verisi:', response.data);

    const categories = [
      { id: 'all', identifier: 'all', name: 'Tümü' }
    ];

    if (response.data?.data) {
      response.data.data.forEach(category => {
        categories.push({
          id: category.id,
          identifier: category.identifier,
          name: category.name
        });
      });
    }

    return categories;
  } catch (error) {
    console.error('Kategoriler getirilirken hata:', error);
    return [{ id: 'all', identifier: 'all', name: 'Tümü' }];
  }
}; 